import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../styles/Layouts';
import { motion } from 'framer-motion';
import card from '../assets/card.svg';

function CardSection() {
  return (
    <CardSectionStyled id="goals">
      <InnerLayout>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: '0.5' }}
        >
          <div className="card-container">
            <div className="card-left">
              <h2 className="secondary-heading">One App for all your photos</h2>
              <p>
                Webapp responsive for the Android and iOS operating systems, and a website. Start backing up your photos
                to the cloud service, which becomes accessible for all of your devices.
              </p>
              <p>
                Recipients of shared images can view web galleries without an app, You can swipe your fingers across the
                screen to adjust the service's photo creating, updating and organize your photos freely.
              </p>
            </div>
            <div className="card-right">
              <img src={card} alt="" />
            </div>
          </div>
        </motion.div>
      </InnerLayout>
    </CardSectionStyled>
  );
}

const CardSectionStyled = styled.section`
  .card-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    @media screen and (max-width: 1347px) {
      grid-template-columns: repeat(1, 1fr);
    }
    .card-left {
      padding-right: 2rem;
      @media screen and (max-width: 787px) {
        padding-right: 0;
      }
      p {
        padding: 2rem 0;
      }
    }
    .card-right {
      position: relative;
      display: flex;
      justify-content: center;
      width: 100%;
      align-items: center;

      img {
        width: 90%;
      }
    }
  }
`;

export default CardSection;
